import { sendGet, sendPost } from "../networking";
import { apiResponse } from "./Interfaces/response";
import { IlingnunUkpiginFormResult } from "../../IlingnunUkpiginForm/ilingnunUkpigin";

export async function submitIlingnunUkpiginHealthDisclosure(
  submission: IlingnunUkpiginFormResult,
  recaptchaToken: string,
  recaptchaAction: string
): Promise<apiResponse> {
  return await sendPost("/api/ilingnun-ukpigin/add", {
    submission,
    recaptchaToken,
    recaptchaAction,
  });
}

export interface IlingnunUkpiginSettings {
  enabled: boolean;
}

export async function getIlingnunUkpiginSettings() {
  return await sendGet<IlingnunUkpiginSettings>(
    "/api/ilingnun-ukpigin-form-enabled"
  );
}
